<button
  mat-icon-button
  class="sm:!text-white"
  [matMenuTriggerFor]="setting_menu"
>
  <mat-icon>settings</mat-icon>
</button>

<mat-menu #setting_menu="matMenu">
  <h4 class="font-bold mb-8 pr-4">نحوه نمایش :</h4>
  <div id="setting_menu" class="p-2">
    <mat-button-toggle-group
      [value]="theme"
      (change)="toggleTheme($event)"
      class="w-[154px] !h-[40px]"
    >
      <mat-button-toggle class="p-1" value="modern">
        <span class="block mx-1"> مدرن </span>
      </mat-button-toggle>
      <mat-button-toggle class="p-1" value="classic">
        <span class="block mx-1"> کلاسیک </span>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
</mat-menu>
